import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { notification } from "antd";
import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import More from "../../../../Components/Icons/More";
import ModalContainer from "../../../../Components/Others/ModalContainer";

const ViewMore = ({ data, getData, id }) => {
  const { officeId } = useParams();

  const tcScheduleEdit = GetAccess("commissioning_schedules_edit");
  const tcScheduleDelete = GetAccess("commissioning_schedules_delete");

  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Delete handler
  const handleDelete = async () => {
    try {
      const res = await axiosInstance.delete(`/tc-schedules/${id}`);
      if (res.status === 200 || res.status === 201) {
        getData();
        api.success({
          message: "Deleted successfully",
          description: res?.data?.msg || "",
          placement: "bottomRight",
        });
      } else {
        api.error({
          message: "Delete failed",
          description: res?.data?.msg || "Network error",
          placement: "bottomRight",
        });
      }
    } catch (error) {
      api.error({
        message: "Delete failed",
        description:
          error?.response?.data?.msg || "Server error (or) Network error",
        placement: "bottomRight",
      });
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="text-[#344767] relative dropdown inline-block z-50">
        <div className="cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center">
          <span
            className="w-7 h-7 bg-gray-50 flex items-center justify-center rounded-full"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <More />
          </span>
        </div>

        <ul className="dropdown-menuOne text-[#344767] text-left rounded-lg absolute -left-[80px] -top-4 overflow-hidden hidden z-50 shadow-lg">
          {/* View */}
          <li className="w-[100px] bg-black block m-0">
            <span className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium">
              <Link
                className="text-black hover:text-black"
                to={`/Contract-management/schedules/view/${data?.id}`}
                state={{ data }}
              >
                View
              </Link>
            </span>
          </li>

          {/* Edit */}
          {tcScheduleEdit && (
            <li className="w-[100px] bg-black block m-0">
              <span className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium">
                <Link
                  className="text-black hover:text-black"
                  to={`/Contract-management/schedules/edit/${data?.id}`}
                  state={{ data }}
                >
                  Edit
                </Link>
              </span>
            </li>
          )}

          {/* Delete */}
          {tcScheduleDelete && (
            <li>
              <button
                className="w-full text-left bg-white hover:bg-gray-100 text-black py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => setIsModalOpen(true)}
              >
                Delete
              </button>
            </li>
          )}
        </ul>
      </div>

      {/* Custom Delete Confirmation Modal */}
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure you want to delete ${data?.refNumber}?`}
        handleClick={handleDelete}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ViewMore;
